/**
 * @description 判断字符串是否为全数字
 * @return {boolean}
 */
export function isPureNumber(str = '') {
  let res = true;
  str.split('').forEach((item) => {
    if (!Number(item)) {
      res = false;
    }
  });
  return res;
}

/**
 * @description 过滤掉特殊字符(非ascii字符且非中文)
 * @return {string} 原字符串去掉特殊字符后的新字符串
 */
export function filterInvalidText(str = '') {
  const res = [];
  for (let i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) < 127 || (str.charCodeAt(i) >= 19968 && str.charCodeAt(i) <= 40869)) {
      res.push(str.charAt(i));
    }
  }
  return res.join('');
}

/**
 * 过滤掉所有非数字的字符
 * @param str
 *
 * 333-444-222 => 333444222
 */
export function filterDigit(str = '') {
  return str.replace(/[^0-9]/gi, '');
}

/**
 * @description 判断字符串中是否包含中文字符
 * @return {boolean}
 */
export function hasChinese(str = '') {
  let res = false;
  for (let i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) >= 19968 && str.charCodeAt(i) <= 40869) {
      res = true;
      break;
    }
  }
  return res;
}

/**
 * base64 encoded ascii to ucs-2 string
 * @param {*} str
 */
export const atou = (str: string) => {
  // eslint-disable-next-line no-param-reassign
  str = str || '';
  try {
    return decodeURIComponent(escape(window.atob(str)));
  } catch (e) {
    return str;
  }
};
